import { Controller } from "@hotwired/stimulus"
import { typingIn } from "./hotkeys_controller"

export default class extends Controller<HTMLElement> {
  static targets = ["row"]

  declare readonly rowTargets: HTMLElement[]

  private index = -1

  move(event: KeyboardEvent): void {
    if (typingIn(event) || this.rowTargets.length === 0) return

    switch (event.key) {
      case "j":
      case "ArrowDown":
        this.focusRow(Math.min(this.index + 1, this.rowTargets.length - 1))
        break
      case "k":
      case "ArrowUp":
        this.focusRow(Math.max(this.index - 1, 0))
        break
      case "x":
        this.current()?.querySelector<HTMLInputElement>("input[type=checkbox]")?.click()
        break
      case "o":
      case "Enter":
        this.current()?.querySelector<HTMLAnchorElement>("a")?.click()
        break
      default:
        return
    }
    event.preventDefault()
  }

  track(event: FocusEvent): void {
    const row = (event.target as HTMLElement).closest<HTMLElement>("[data-approval-queue-target=row]")
    if (row !== null) this.index = this.rowTargets.indexOf(row)
  }

  count(): void {
    const selected = this.element.querySelectorAll("input[name='timesheet_ids[]']:checked").length
    const noun = selected === 1 ? "timesheet" : "timesheets"
    this.element.dataset.turboConfirm = `Approve ${selected} selected ${noun}? Approving certifies you reviewed each one, and it locks them.`
  }

  private current(): HTMLElement | undefined {
    return this.rowTargets[this.index]
  }

  private focusRow(index: number): void {
    this.index = index
    this.rowTargets[index]?.focus()
  }
}
